import React, { FunctionComponent } from 'react'

import { PropertyLabel } from '../../../common/propertyDetailTypes'
import { LabelConnectionFragment } from '../../utils/labelsTypes'
import { bulkEditTransition } from '../../utils/layoutConst'
import { ExportTableXlsxButton } from '../ExportTableXlsxButton/ExportTableXlsxButton'
import { Fade } from '../Fade/Fade'
import { PropertyLabelTableBulkEditLabel } from '../PropertyLabelTableBulkEditLabel/PropertyLabelTableBulkEditLabel'
import { TableItemsCount } from '../TableItemsCount/TableItemsCount'

export interface PropertyLabelTableBulkEditProps {
  selectedRows: (PropertyLabel & { labels?: LabelConnectionFragment | null })[]
  refetch: () => void
  limit?: number
}

const DEFAULT_LIMIT = 100

export const PropertyLabelTableBulkEdit: FunctionComponent<PropertyLabelTableBulkEditProps> =
  ({ selectedRows, refetch, limit = DEFAULT_LIMIT }) => {
    const count = selectedRows?.length || 0

    return (
      <Fade
        transition={bulkEditTransition}
        show={!!count}
        className="flex space-x-4 items-center mb-4"
      >
        <PropertyLabelTableBulkEditLabel
          selectedRows={selectedRows}
          refetch={refetch}
          limit={limit}
        />
        <ExportTableXlsxButton
          url="propertyLabel/propertyXlsx"
          fileName="Nemovitosti"
          dataSource={selectedRows}
        />
        <TableItemsCount prefix="Vybráno" separator total={count} />
      </Fade>
    )
  }
